import "./assets/styles/Main.scss";
import "bootstrap/dist/js/bootstrap.js";

import { AppRoutes } from "./routes";
import {
  AuthProvider,
  BrandingProvider,
  ConfigProvider,
  FeatureFlagProvider,
  GlobalStateProvider
} from "./providers";

function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <FeatureFlagProvider>
          <BrandingProvider>
            <GlobalStateProvider>
                <AppRoutes />
            </GlobalStateProvider>
          </BrandingProvider>
        </FeatureFlagProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
